import React from 'react';

const ValueHolder = () => {
	return <input type="hidden" />;
};

export default ValueHolder;
